export default "Prêts Banque des Territoires — Collectivités | Solution Éco France";
